var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wallet.deleted_at)?_c('Badge',{attrs:{"color":"danger","icon":"trash"}},[_vm._v("Trashed")]):_c('UIBoolean',{attrs:{"value":_vm.wallet.enabled,"color":_vm.color,"textOn":"Enabled","textOff":"Disabled"}})}
var staticRenderFns = []

export { render, staticRenderFns }